import { 
  SHOW_EMERGENCY_ALERT, 
  HIDE_EMERGENCY_ALERT, 
  CLEAR_EMERGENCY_ALERTS 
} from "./emergencyAlertActions";

const getInitialState = () => {
  try {
    const savedAlerts = localStorage.getItem("emergencyAlerts");
    if (savedAlerts) {
      return JSON.parse(savedAlerts);
    }
  } catch (error) {
    console.error("Failed to load alerts from localStorage:", error);
  }
  return {
    alerts: [],
    activeAlert: null,
  };
};

const initialState = getInitialState();

const emergencyAlertReducer = (state = initialState, action) => {
  let newState;

  switch (action.type) {
    case SHOW_EMERGENCY_ALERT:
      newState = {
        ...state,
        alerts: [...state.alerts, action.payload],
        activeAlert: action.payload.id,
      };
      localStorage.setItem("emergencyAlerts", JSON.stringify(newState));
      return newState;

    case HIDE_EMERGENCY_ALERT:
      newState = {
        ...state,
        alerts: state.alerts.filter((alert) => alert.id !== action.payload),
        activeAlert: state.activeAlert === action.payload ? null : state.activeAlert,
      };
      localStorage.setItem("emergencyAlerts", JSON.stringify(newState));
      return newState;

    case CLEAR_EMERGENCY_ALERTS:
      newState = {
        ...state,
        alerts: [],
        activeAlert: null,
      };
      localStorage.removeItem("emergencyAlerts");
      return newState;

    default:
      return state;
  }
};

export default emergencyAlertReducer;